<template>
  <router-link
    v-if="to"
    :to="to"
    :class="[
      'nav-link',
      active ? 'active' : '',
    ]"
  >
    <div class="nav">
      <div class="logo-container">
        <img
          v-if="active"
          :class="iconClass"
          :src="require(`@shared/assets/img/navbar/${activeIcon}`)"
        >
        <img
          v-else
          :class="iconClass"
          :src="require(`@shared/assets/img/navbar/${icon}`)"
        >
      </div>
      <div class="nav-label-container">
        <span class="nav-label">
          {{ label }}
        </span>
      </div>
    </div>
  </router-link>
  <a
    v-else
    :href="redirect"
    :class="[
      'nav-link',
      active ? 'active' : '',
    ]"
  >
    <div class="nav">
      <div class="logo-container">
        <img
          v-if="active"
          :class="iconClass"
          :src="require(`@shared/assets/img/navbar/${activeIcon}`)"
        >
        <img
          v-else
          :class="iconClass"
          :src="require(`@shared/assets/img/navbar/${icon}`)"
        >
      </div>
      <div class="nav-label-container">
        <span class="nav-label">
          {{ label }}
        </span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'NavItem',
  props: {
    to: String,
    redirect: String,
    label: String,
    active: Boolean,
    icon: String,
    activeIcon: String,
    iconClass: String,
  },
};
</script>
